const action_library_messages = {
  page_title: ['action_library>>page_title', 'Action Library'],
  create_button: ['action_library>>create_button', 'Create New Action Template'],
  create_subtitle: [
    'action_library>>create_subtitle',
    'Here you can create a new action template. Define its properties and create a checklist of steps to follow.',
  ],
  draft_activation_warning: [
    'action_library>>draft_activation_warning',
    'This template has unpublished changes. Activation applies to the published version only.',
  ],
  edit_subtitle: [
    'action_library>>edit_subtitle',
    'Here you can edit the action template. Update its properties and modify the checklist of steps.',
  ],
  empty_state: {
    title: ['action_library>>empty_state>>title', 'No matching templates found'],
    description: ['action_library>>empty_state>>description', 'Try adjusting your filters or search criteria'],
    reset_filters: ['action_library>>empty_state>>reset_filters', 'Reset Filters'],
  },
  error_state: {
    title: ['action_library>>error_state>>title', 'Something went wrong'],
    description: ['action_library>>error_state>>description', 'Failed to load action templates. Please try again.'],
    retry: ['action_library>>error_state>>retry', 'Retry'],
    unauthorized: {
      title: ['action_library>>error_state>>unauthorized>>title', 'Unauthorized Access'],
      description: ['action_library>>error_state>>unauthorized>>description', 'You do not have permission to access this resource.'],
      back_to_start: ['action_library>>error_state>>unauthorized>>back_to_start', 'Back to Start'],
    },
    timeout: {
      title: ['action_library>>error_state>>timeout>>title', 'Request Timeout'],
      description: [
        'action_library>>error_state>>timeout>>description',
        'The request took too long to complete. Please check your connection and try again.',
      ],
      retry: ['action_library>>error_state>>timeout>>retry', 'Retry'],
    },
  },
  table: {
    fresh_changes_tooltip: ['action_library>>table>>fresh_changes_tooltip', 'This version was updated within the last 30 days'],
    name: ['action_library>>table>>name', 'Name'],
    purpose: ['action_library>>table>>purpose', 'Purpose'],
    area: ['action_library>>table>>area', 'Area'],
    subarea: ['action_library>>table>>subarea', 'Subarea'],
    status: ['action_library>>table>>status', 'Status'],
    criticality: ['action_library>>table>>criticality', 'Criticality'],
    creator: ['action_library>>table>>creator', 'Creator'],
    actions: ['action_library>>table>>actions', 'Actions'],
    show_more: ['action_library>>table>>show_more', 'Show More'],
  },
  detail: {
    page_title: ['action_library>>detail>>page_title', 'Action Template Details'],
    title: ['action_library>>detail>>title', 'Action Template Details'],
    description: ['action_library>>detail>>description', 'Description'],
    tags: ['action_library>>detail>>tags', 'Tags'],
    steps: ['action_library>>detail>>steps', 'Steps'],
    list_of_steps: ['action_library>>detail>>list_of_steps', 'List of steps'],
    created_at: ['action_library>>detail>>created_at', 'Created At'],
    updated_at: ['action_library>>detail>>updated_at', 'Updated At'],
    created_by: ['action_library>>detail>>created_by', 'Created By'],
    validity_period: ['action_library>>detail>>validity_period', 'Validity Period'],
    owner_organization: ['action_library>>detail>>owner_organization', 'Owner Organization'],
    asset_types: ['action_library>>detail>>asset_types', 'Asset Types'],
    reference: ['action_library>>detail>>reference', 'Reference'],
    reported_to: ['action_library>>detail>>reported_to', 'Reported To'],
  },
  actions: {
    activate: ['action_library>>actions>>activate', 'Activate'],
    deactivate: ['action_library>>actions>>deactivate', 'Deactivate'],
    copy: ['action_library>>actions>>copy', 'Copy'],
    print: ['action_library>>actions>>print', 'Print'],
    delete: ['action_library>>actions>>delete', 'Delete'],
    edit: ['action_library>>actions>>edit', 'Edit'],
  },
  status: {
    active: ['action_library>>status>>active', 'Active'],
    inactive: ['action_library>>status>>inactive', 'Inactive'],
    draft: ['action_library>>status>>draft', 'Draft'],
  },
  criticality: {
    LOW: ['action_library>>criticality>>LOW', 'Low'],
    MEDIUM: ['action_library>>criticality>>MEDIUM', 'Medium'],
    HIGH: ['action_library>>criticality>>HIGH', 'High'],
  },
  creator: {
    PocketSafe: ['action_library>>creator>>PocketSafe', 'PocketSafe'],
    Organization: ['action_library>>creator>>Organization', 'Organization'],
  },
  delete_confirmation: {
    title: ['action_library>>delete_confirmation>>title', 'Delete Action Template'],
    body: [
      'action_library>>delete_confirmation>>body',
      'Are you sure you want to delete this action template? This action cannot be undone.',
    ],
    confirm: ['action_library>>delete_confirmation>>confirm', 'Delete'],
    cancel: ['action_library>>delete_confirmation>>cancel', 'Cancel'],
  },
  success: {
    created: ['action_library>>success>>created', 'Action template created successfully'],
    updated: ['action_library>>success>>updated', 'Action template updated successfully'],
    deleted: ['action_library>>success>>deleted', 'Action template deleted successfully'],
    activated: ['action_library>>success>>activated', 'Action template activated successfully'],
    deactivated: ['action_library>>success>>deactivated', 'Action template deactivated successfully'],
    copied: ['action_library>>success>>copied', 'Action template copied successfully'],
    instance_created: ['action_library>>success>>instance_created', 'Action library instances created successfully'],
    instance_updated: ['action_library>>success>>instance_updated', 'Action library instance updated successfully'],
    instance_deleted: ['action_library>>success>>instance_deleted', 'Action library instance deleted successfully'],
    save_changes: ['action_library>>save_changes', 'Save Changes'],
  },
  errors: {
    template_delete_failed: ['action_library>>errors>>template_delete_failed', 'Failed to delete template'],
    template_status_update_failed: ['action_library>>errors>>template_status_update_failed', 'Failed to update template status'],
    instance_create_failed: ['action_library>>errors>>instance_create_failed', 'Failed to create action library instances'],
    no_template_selected: ['action_library>>errors>>no_template_selected', 'No template selected'],
    unknown_step: ['action_library>>errors>>unknown_step', 'Unknown step'],
    reminder_error_prefix: ['action_library>>errors>>reminder_error_prefix', 'Reminder: {{error}}'],
    deadline_error_prefix: ['action_library>>errors>>deadline_error_prefix', 'Deadline: {{error}}'],
    instance_update_failed: ['action_library>>errors>>instance_update_failed', 'Failed to update action library instance'],
  },
  wizard: {
    next: ['action_library>>wizard>>next', 'Next'],
    back: ['action_library>>wizard>>back', 'Back'],
    review: ['action_library>>wizard>>review', 'Review'],
    step_select_template: ['action_library>>wizard>>step_select_template', 'Select template'],
    step_time_parameters: ['action_library>>wizard>>step_time_parameters', 'Time parameters'],
    step_assets: ['action_library>>wizard>>step_assets', 'Assets'],
  },
  time: {
    month: ['action_library>>time>>month', 'month'],
    months: ['action_library>>time>>months', 'months'],
  },
  filters: {
    purpose: ['action_library>>filters>>purpose', 'Purpose'],
    area: ['action_library>>filters>>area', 'Area'],
    subarea: ['action_library>>filters>>subarea', 'Subarea'],
    status: ['action_library>>filters>>status', 'Status'],
    criticality: ['action_library>>filters>>criticality', 'Criticality'],
    creator: ['action_library>>filters>>creator', 'Creator'],
    due_date: ['action_library>>filters>>due_date', 'Due date up to'],
    overdue: ['action_library>>filters>>overdue', 'Overdue'],
    past_reminder: ['action_library>>filters>>past_reminder', 'Past reminder'],
    asset_importance: ['action_library>>filters>>asset_importance', 'Asset importance'],
  },
  steps: {
    step_title: ['action_library>>steps>>step_title', 'Step {{number}}'],
    title: ['action_library>>steps>>title', 'Title'],
    instruction: ['action_library>>steps>>instruction', 'Instruction'],
    mandatory: ['action_library>>steps>>mandatory', 'Mandatory *'],
    mandatory_yes: ['action_library>>steps>>mandatory_yes', 'Yes'],
    mandatory_no: ['action_library>>steps>>mandatory_no', 'No'],
    related_reading: ['action_library>>steps>>related_reading', 'Related reading'],
    relevant_for: ['action_library>>steps>>relevant_for', 'Relevant for'],
    at_least_one_required: ['action_library>>steps>>at_least_one_required', 'At least one step is required'],
    add_step: ['action_library>>steps>>add_step', 'Add Step'],
    save_template: ['action_library>>steps>>save_template', 'Save & continue'],
    update_template: ['action_library>>steps>>update_template', 'Save & Publish'],
    cancel: ['action_library>>steps>>cancel', 'Cancel'],
    save_and_publish_confirm_title: ['action_library>>steps>>save_and_publish_confirm_title', 'Are you sure?'],
    save_and_publish_confirm_body: [
      'action_library>>steps>>save_and_publish_confirm_body',
      'Your changes will be saved and published. Do you want to continue?',
    ],
  },
  help: {
    title: ['action_library>>help>>title', 'Action Library - how it works?'],
    body: [
      'action_library>>help>>body',
      'It works perfectly - lorem ipsum, description is needed here, and <b>HTML</b> is also possible, so we need some more description here please',
    ],
  },
  properties: {
    section_title: ['action_library>>properties>>section_title', 'Action Template Properties'],
    title: ['action_library>>properties>>title', 'Title'],
    purpose: ['action_library>>properties>>purpose', 'Purpose'],
    asset_types: ['action_library>>properties>>asset_types', 'Asset Types'],
    criticality: ['action_library>>properties>>criticality', 'Criticality'],
    short_description: ['action_library>>properties>>short_description', 'Short Description'],
    area: ['action_library>>properties>>area', 'Area'],
    subarea: ['action_library>>properties>>subarea', 'Subarea'],
    tags: ['action_library>>properties>>tags', 'Tags'],
    reference: ['action_library>>properties>>reference', 'Reference'],
    reported_to: ['action_library>>properties>>reported_to', 'Reported to'],
    validity_period: ['action_library>>properties>>validity_period', 'Validity Period'],
    duration_in_months: ['action_library>>properties>>duration_in_months', 'Duration (in months)'],
    doesnt_apply: ['action_library>>properties>>doesnt_apply', "Doesn't apply"],
  },
  instance: {
    page_title: ['action_library>>instance>>page_title', 'Action Library Instances'],
    create_title: ['action_library>>instance>>create_title', 'Create Action Library Instance'],
    create_button: ['action_library>>instance>>create_button', 'Create Action Library Instance'],
    create_subtitle: ['action_library>>instance>>create_subtitle', 'Create new action instances'],
    edit_title: ['action_library>>instance>>edit_title', 'Edit Action Library Instance'],
    edit_subtitle: ['action_library>>instance>>edit_subtitle', 'Update the properties and steps of this action instance'],
    steps: {
      select_template: ['action_library>>instance>>steps>>select_template', 'Select template'],
      time_parameters: ['action_library>>instance>>steps>>time_parameters', 'Time parameters'],
      assets: ['action_library>>instance>>steps>>assets', 'Assets'],
    },
    form: {
      instance_name: ['action_library>>instance>>form>>instance_name', 'Instance Name'],
      deadline: ['action_library>>instance>>form>>deadline', 'Deadline date'],
      reminder: ['action_library>>instance>>form>>reminder', 'Reminder date'],
      date: ['action_library>>instance>>form>>date', 'Date'],
      time: ['action_library>>instance>>form>>time', 'Time'],
      special_instruction: ['action_library>>instance>>form>>special_instruction', 'Special Instruction (optional)'],
      special_instruction_label: ['action_library>>instance>>form>>special_instruction_label', 'Special instruction'],
      steps_section_title: ['action_library>>instance>>form>>steps_section_title', 'Steps'],
      steps_section_description: ['action_library>>instance>>form>>steps_section_description', 'Review steps and mark mandatory ones.'],
      mandatory: ['action_library>>instance>>form>>mandatory', 'Mandatory'],
      template_selected: ['action_library>>instance>>form>>template_selected', 'Template selected'],
      instance_details: ['action_library>>instance>>form>>instance_details', 'Instance Details'],
      validity_period_not_set: ['action_library>>instance>>form>>validity_period_not_set', 'Validity Period: not set'],
      validity_period_text: ['action_library>>instance>>form>>validity_period_text', 'Validity Period: {{months}} {{unit}}'],
      month: ['action_library>>instance>>form>>month', 'month'],
      months: ['action_library>>instance>>form>>months', 'months'],
      steps_count: ['action_library>>instance>>form>>steps_count', 'Steps: {{count}}'],
      change_template: ['action_library>>instance>>form>>change_template', 'Change'],
      select_template_button: ['action_library>>instance>>form>>select_template_button', 'Select'],
      no_templates_found: ['action_library>>instance>>form>>no_templates_found', 'No templates found.'],
      search_placeholder: ['action_library>>instance>>form>>search_placeholder', 'Search by name, description, tags...'],
      all_areas: ['action_library>>instance>>form>>all_areas', 'All Areas'],
      all_subareas: ['action_library>>instance>>form>>all_subareas', 'All Sub-areas'],
      reported_to: ['action_library>>instance>>form>>reported_to', 'Reported To'],
      template_summary: ['action_library>>instance>>form>>template_summary', 'Template Summary'],
      mandatory_tooltip: ['action_library>>instance>>form>>mandatory_tooltip', 'Mandatory steps must be completed to finish the instance.'],
      how_does_it_work: ['action_library>>instance>>form>>how_does_it_work', 'How does it work?'],
      metadata: ['action_library>>instance>>form>>metadata', 'Metadata'],
      owner_type: ['action_library>>instance>>form>>owner_type', 'Owner Type'],
      validity_period: ['action_library>>instance>>form>>validity_period', 'Validity Period'],
      asset_categories: ['action_library>>instance>>form>>asset_categories', 'Asset Categories'],
    },
    asset_selection: {
      title: ['action_library>>instance>>asset_selection>>title', 'Select Assets'],
      description: [
        'action_library>>instance>>asset_selection>>description',
        'Search and select the assets you want to create instances for.',
      ],
      search_placeholder: ['action_library>>instance>>asset_selection>>search_placeholder', 'Search by name, owner or type...'],
      recommended_section: ['action_library>>instance>>asset_selection>>recommended_section', 'Recommended Assets'],
      others_section: ['action_library>>instance>>asset_selection>>others_section', 'Other Assets'],
      select_all: ['action_library>>instance>>asset_selection>>select_all', 'Select All'],
      deselect_all: ['action_library>>instance>>asset_selection>>deselect_all', 'Deselect All'],
      no_assets_found: ['action_library>>instance>>asset_selection>>no_assets_found', 'No assets found'],
      no_recommended_assets: [
        'action_library>>instance>>asset_selection>>no_recommended_assets',
        'No recommended assets found for this template',
      ],
      loading: ['action_library>>instance>>asset_selection>>loading', 'Loading assets...'],
      selected_count: ['action_library>>instance>>asset_selection>>selected_count', '{{count}} asset selected'],
      selected_count_plural: ['action_library>>instance>>asset_selection>>selected_count_plural', '{{count}} assets selected'],
      asset_details_format: [
        'action_library>>instance>>asset_selection>>asset_details_format',
        '{{ownerLabel}}: {{ownerName}} | {{categoryLabel}}: {{categoryName}}',
      ],
    },
    validation: {
      template_required: ['action_library>>instance>>validation>>template_required', 'Please select a template'],
      instance_name_required: ['action_library>>instance>>validation>>instance_name_required', 'Instance name is required'],
      deadline_date_required: ['action_library>>instance>>validation>>deadline_date_required', 'Deadline date is required'],
      deadline_time_required: ['action_library>>instance>>validation>>deadline_time_required', 'Deadline time is required'],
      reminder_date_required: ['action_library>>instance>>validation>>reminder_date_required', 'Reminder date is required'],
      reminder_time_required: ['action_library>>instance>>validation>>reminder_time_required', 'Reminder time is required'],
      assets_required: ['action_library>>instance>>validation>>assets_required', 'Assets are required'],
      assets_min: ['action_library>>instance>>validation>>assets_min', 'Please select at least one asset'],
      reminder_before_deadline: [
        'action_library>>instance>>validation>>reminder_before_deadline',
        'Reminder cannot be later than the deadline',
      ],
    },
    summary_dialog: {
      title: ['action_library>>instance>>summary_dialog>>title', 'Confirm Action Instance Creation'],
      general_info: ['action_library>>instance>>summary_dialog>>general_info', 'General Info'],
      template: ['action_library>>instance>>summary_dialog>>template', 'Template:'],
      template_details: ['action_library>>instance>>summary_dialog>>template_details', 'Template Details'],
      area: ['action_library>>instance>>summary_dialog>>area', 'Area:'],
      purpose: ['action_library>>instance>>summary_dialog>>purpose', 'Purpose:'],
      criticality: ['action_library>>instance>>summary_dialog>>criticality', 'Criticality:'],
      reference: ['action_library>>instance>>summary_dialog>>reference', 'Reference:'],
      instance_name: ['action_library>>instance>>summary_dialog>>instance_name', 'Instance Name:'],
      reported_to: ['action_library>>instance>>summary_dialog>>reported_to', 'Reported to:'],
      time_parameters: ['action_library>>instance>>summary_dialog>>time_parameters', 'Time Parameters'],
      deadline: ['action_library>>instance>>summary_dialog>>deadline', 'Deadline:'],
      reminder: ['action_library>>instance>>summary_dialog>>reminder', 'Reminder:'],
      special_instructions: ['action_library>>instance>>summary_dialog>>special_instructions', 'Special Instructions (Optional)'],
      steps: ['action_library>>instance>>summary_dialog>>steps', 'Steps'],
      mandatory: ['action_library>>instance>>summary_dialog>>mandatory', 'Mandatory'],
      optional: ['action_library>>instance>>summary_dialog>>optional', 'Optional'],
      selected_assets: ['action_library>>instance>>summary_dialog>>selected_assets', 'Selected Assets'],
      owner_label: ['action_library>>instance>>summary_dialog>>owner_label', 'Owner:'],
      not_available: ['action_library>>instance>>summary_dialog>>not_available', 'N/A'],
      no_assets_selected: ['action_library>>instance>>summary_dialog>>no_assets_selected', 'No assets selected'],
      cancel: ['action_library>>instance>>summary_dialog>>cancel', 'Cancel'],
      creating: ['action_library>>instance>>summary_dialog>>creating', 'Creating...'],
      create_instance: ['action_library>>instance>>summary_dialog>>create_instance', 'Create Instance'],
    },
    detail: {
      page_title: ['action_library>>instance>>detail>>page_title', 'Action Instance Details'],
      title: ['action_library>>instance>>detail>>title', 'Title'],
      description: ['action_library>>instance>>detail>>description', 'Description'],
      special_instruction: ['action_library>>instance>>detail>>special_instruction', 'Special Instruction'],
      status: ['action_library>>instance>>detail>>status', 'Status'],
      criticality: ['action_library>>instance>>detail>>criticality', 'Criticality'],
      asset: ['action_library>>instance>>detail>>asset', 'Asset'],
      asset_name: ['action_library>>instance>>detail>>asset_name', 'Asset Name'],
      asset_type: ['action_library>>instance>>detail>>asset_type', 'Asset Type'],
      asset_importance: ['action_library>>instance>>detail>>asset_importance', 'Asset Importance'],
      owner: ['action_library>>instance>>detail>>owner', 'Owner'],
      delegated_to: ['action_library>>instance>>detail>>delegated_to', 'Delegated To'],
      deadline: ['action_library>>instance>>detail>>deadline', 'Deadline'],
      reminder: ['action_library>>instance>>detail>>reminder', 'Reminder'],
      created_at: ['action_library>>instance>>detail>>created_at', 'Created At'],
      updated_at: ['action_library>>instance>>detail>>updated_at', 'Updated At'],
      status_percent: ['action_library>>instance>>detail>>status_percent', 'Progress'],
    },
  },
};

export default action_library_messages;
